import { getApiBase } from './apiBase';

export async function loginWithGoogleCredential(credential) {
    const url = `${getApiBase()}/auth/google`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential }),
    });
    if (!res.ok) {
        throw new Error('Falha ao autenticar com Google');
    }
    return res.json();
}

export async function fetchMe(token) {
    const url = `${getApiBase()}/auth/me`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
        throw new Error('Sessão inválida');
    }
    return res.json();
}

export async function fetchAdminStats(token) {
    const url = `${getApiBase()}/admin/stats`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
        throw new Error('Falha ao carregar estatísticas');
    }
    return res.json();
}

export async function fetchAdminUsers(token, { q = '', limit = 50, offset = 0 } = {}) {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (limit) params.set('limit', String(limit));
    if (offset) params.set('offset', String(offset));
    const qs = params.toString();
    const url = `${getApiBase()}/admin/users${qs ? `?${qs}` : ''}`;
    const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
        throw new Error('Falha ao carregar usuários');
    }
    return res.json();
}
